const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "0.0.0.0"]);
const RESERVED_SUBDOMAINS = new Set(["www", "api"]);

export const getRuntimeHostname = () => {
  if (typeof window === "undefined") {
    return "localhost";
  }

  return window.location.hostname;
};

const toTenantName = (tenantId: string) =>
  tenantId
    .split(/[-_.]/g)
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(" ");

export const resolveTenantId = (hostname: string, envTenantId?: string) => {
  if (envTenantId?.trim()) {
    return envTenantId.trim();
  }

  if (LOCAL_HOSTS.has(hostname)) {
    return null;
  }

  if (hostname === "erpkimhoan.vn") {
    return null;
  }

  // Handle subdomains for both local and production
  if (
    hostname.endsWith(".erpgold.local") ||
    hostname.endsWith(".erpkimhoan.vn") ||
    hostname.endsWith(".local") ||
    hostname.endsWith(".localhost")
  ) {
    const [subdomain] = hostname.split(".");
    return subdomain && !RESERVED_SUBDOMAINS.has(subdomain) ? subdomain : null;
  }

  const [firstSegment] = hostname.split(".");
  return firstSegment || null;
};

export const resolveTenantName = (tenantId: string) => toTenantName(tenantId);
